import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import moment from "moment";
import Header from './header';

export default function App() {
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);
    const dateNext = moment(app.selectedDate).add(1, 'month');
    const datePrev = moment(app.selectedDate).add(-1, 'month');

    return (
        <View>
            <View style={styles.calendar}>
                <TouchableOpacity onPress={() => dispatch({type: 'date', payload: datePrev})}>
                    <View style={styles.dateHolder}>
                        <Text style={styles.text}>{datePrev.format('MMMM')}</Text>
                        <Text style={styles.text}>{datePrev.format('YYYY')}</Text>
                    </View>
                </TouchableOpacity>
                <View style={styles.dateHolder}>
                    <Text style={styles.selected}>{app.selectedDate.format('MMMM')}</Text>
                    <Text style={styles.selected}>{app.selectedDate.format('YYYY')}</Text>
                </View>
                <TouchableOpacity onPress={() => dispatch({type: 'date', payload: dateNext})}>
                    <View style={styles.dateHolder}>
                        <Text style={styles.text}>{dateNext.format('MMMM')}</Text>
                        <Text style={styles.text}>{dateNext.format('YYYY')}</Text>
                    </View>
                </TouchableOpacity>
            </View>
        </View>
    );
  }
  
  const styles = StyleSheet.create({
    calendar: {
      padding: 5,
      display: 'flex',
      backgroundColor: '#41335e',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexDirection: 'row',
      marginTop: 0
    },
    dateHolder: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    text: {
        color: '#aaa',
        fontSize: 15
      },
    selected: {
        color: 'white',
        fontSize: 20,
        fontWeight: 'bold'
      }
      });
  